import { Directive } from '@angular/core';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';
import { BaseFormConnectorDirective } from './base-form-connector.directive';

@Directive({
  selector: '[dsdExtSelectConnector], dsd-select',
  providers: [
    {
      provide: FormErrorConnectorDirective,
      useExisting: SelectConnectorDirective
    }
  ],
  standalone: false
})
export class SelectConnectorDirective extends BaseFormConnectorDirective {}
